import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    async function run() {
      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }
      try {
        const res = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(res.data);
        window.history.replaceState({}, document.title, "/owner");
        navigate("/owner", { replace: true, state: { user: res.data } });
      } catch {
        navigate("/?auth_error=1", { replace: true });
      }
    }
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#070B14] text-slate-200">
      <Loader2 className="w-8 h-8 animate-spin text-amber-300" />
      <p className="mt-4 text-sm text-slate-400">Signing you in…</p>
    </div>
  );
}
